import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useLoginStore } from '@lib/store';
import { cn, LocalStorageUtils, RoutePaths } from '@shared/utils';
import { Button, Checkbox, Input } from '@shared/widgets';

interface IForm {
  userName: string;
  password: string;
  remember: boolean;
}
const DEFAULT_VALUES = { userName: '', password: '', remember: false };

interface LoginFormProps {
  className?: string;
}

export const LoginForm = (props: LoginFormProps) => {
  const loginStore = useLoginStore();

  const { control, formState, handleSubmit, reset } = useForm<IForm>({
    defaultValues: { ...DEFAULT_VALUES, userName: LocalStorageUtils.getUsername(), remember: !!LocalStorageUtils.getUsername() },
  });

  const submitHandler = async (data: IForm) => {
    const result = await loginStore.login({ Login: data.userName, Password: data.password });
    console.log(result);

    data.remember ? LocalStorageUtils.setUsername(data.userName) : LocalStorageUtils.removeUsername();
    reset(DEFAULT_VALUES);
  };

  return (
    <div className={props.className}>
      <form className='flex flex-col' onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='userName'
          control={control}
          rules={{ required: true }}
          render={({ field }) => <Input {...field} name='User Name' placeholder='USERNAME' />}
        />
        <Controller
          name='password'
          control={control}
          rules={{ required: true }}
          render={({ field }) => <Input {...field} className='mt-4' name='Password' type='password' placeholder='PASSWORD' />}
        />
        <Controller
          name='remember'
          control={control}
          render={({ field: { value, onChange } }) => (
            <Checkbox className='mt-8 mb-11 uppercase' title='Remember my username' checked={value} onChange={onChange} />
          )}
        />
        <Button className='h-[56px]' type='submit' disabled={!formState.isValid || formState.isSubmitting}>
          Login
        </Button>
      </form>
      <div className='mt-7 text-center'>
        <Link
          className={cn('cursor-pointer text-sm text-[#ffffff80] uppercase transition-colors duration-200', 'hover:text-[#f2f2f2]')}
          to={RoutePaths.recovery.onNavigate()}
        >
          Have you forgotten your password?
        </Link>
      </div>
      {/* <Link to={RoutePaths.applyNow.onNavigate()}>
        <Button className='mt-10.5 h-[56px]' fullWidth color='outlined'>
          Apply Now
        </Button>
      </Link> */}
    </div>
  );
};
